<div class="flex flex-col items-center gap-4">
  <div class="flex flex-col items-center gap-3">
    <img src="assets/images/zaeper_logo_z.svg" alt="Zaeper" class="w-14 h-14 dark:hidden" />
    <img src="assets/images/zaeper_logo_z_white.svg" alt="Zaeper" class="w-14 h-14 hidden dark:block" />
    <span class="text-xl font-bold text-surface-900 dark:text-surface-0">Zaeper User Dashboard</span>
    <span class="text-sm text-surface-500 dark:text-surface-400">v{{ appVersion }}</span>
  </div>

  @if (activeCompany) {
    <div class="w-full flex flex-col gap-3">
      <div class="p-4 rounded-xl bg-surface-50 dark:bg-surface-800 border border-surface-200 dark:border-surface-700">
        <div class="flex items-center gap-3">
          <div class="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <i class="pi pi-building text-lg text-primary"></i>
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-surface-900 dark:text-surface-0">{{ activeCompany.name }}</div>
            <div class="text-sm text-surface-500 dark:text-surface-400">{{ activeCompany.shortcode }}</div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (activeLicense) {
    <div class="w-full flex flex-col gap-3">
      <div class="p-4 rounded-xl bg-surface-50 dark:bg-surface-800 border border-surface-200 dark:border-surface-700">
        <div class="flex items-center gap-3">
          <div class="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <i class="pi pi-id-card text-lg text-primary"></i>
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-surface-900 dark:text-surface-0">{{ activeLicense.status }}</div>
            <div class="text-sm text-surface-500 dark:text-surface-400">{{ activeLicense.billingType }}</div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
